export default "__VITE_ASSET__YA4$gt8r__"